module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "globalLoading",
    class: {
      shown: _vm.shown
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doNothing($event)
      }
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', [_vm._v(_vm._s(_vm.text))]), _c('i', {
    staticClass: "fa fa-spin fa-refresh"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63a4eb28","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalLoading.vue
// module id = 887
// module chunks = 13